export function calculateRemainingMonths(numberOfMonths, fiscalYear) {
    const currentDate = new Date(); // Replace with new Date("2025-04-01") for testing
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    const fiscalYearMonths = [7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6];
    const isAfterJuly = currentMonth >= 7;

    // Determine the current fiscal year
    const currentFiscalYear = isAfterJuly ? currentYear + 1 : currentYear;

    // If the target fiscal year is in the past, return an empty array
    if (fiscalYear < currentFiscalYear) {
        return [];
    }

    // If the target fiscal year matches the current fiscal year
    if (fiscalYear === currentFiscalYear) {
        const startIndex = fiscalYearMonths.indexOf(currentMonth);
        const remainingMonths = fiscalYearMonths.slice(startIndex);
        return remainingMonths.slice(numberOfMonths);
    }

    // If the target fiscal year is in the future, return the full fiscal year months
    return fiscalYearMonths;
}